import React from 'react';

const Avatar = ({ email, isTyping, photo }) => {
    // Generate a consistent color based on the email
    const getColor = (email) => {
        if (!email) return '#ccc';
        let hash = 0;
        for (let i = 0; i < email.length; i++) {
            hash = email.codePointAt(i) + ((hash << 5) - hash);
        }
        const c = (hash & 0x00FFFFFF).toString(16).toUpperCase();
        return '#' + '00000'.substring(0, 6 - c.length) + c;
    };

    // Get initials from email
    const getInitials = (email) => {
        if (!email) return '?';
        return email.charAt(0).toUpperCase();
    };

    const backgroundColor = getColor(email);
    const showPhoto = !isTyping && !!photo;

    const renderAvatarContent = () => {
        if (isTyping) {
            return (
                <div className="typing-dots">
                    <div className="typing__dot"></div>
                    <div className="typing__dot"></div>
                    <div className="typing__dot"></div>
                </div>
            );
        }

        if (showPhoto) {
            return (
                <img
                    src={photo}
                    alt={email}
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        borderRadius: '50%'
                    }}
                />
            );
        }

        return (
            <span className="text-xs font-medium text-white">
                {getInitials(email)}
            </span>
        );
    };

    return (
        <div
            className="avatar-container"
            title={email}
            style={{
                position: 'relative',
                display: 'inline-block',
                marginLeft: '5px'
            }}
        >
            <span
                className="inline-flex items-center justify-center rounded-full outline outline-offset-1 outline-black/5"
                style={{
                    width: '2.5em',
                    height: '2.5em',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '50%',
                    backgroundColor: showPhoto ? 'transparent' : backgroundColor,
                    color: 'white',
                    fontSize: '0.8rem',
                    fontWeight: 'bold',
                    border: '2px solid white',
                    boxShadow: '0 0 0 1px rgba(0,0,0,0.1)',
                    overflow: 'hidden'
                }}
            >
                {renderAvatarContent()}
            </span>
        </div>
    );
};

export default Avatar;
